import { mobileXLargeMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import { Button as ButtonPillRow } from '@propertypal/web-ui/src/buttons/ButtonPillRow.style';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import styled, { css } from 'styled-components';
import { filterBreakpoint } from './SearchBar/SearchBar.style';

export const Title = styled.h1`
  font-size: 36px;
  color: ${(props) => props.theme.textDark};
  font-family: ${platform.headingFont};

  @media (${mobileXLargeMax}) {
    font-size: 28px;
  }
`;

export const SearchHeader = styled.div`
  display: flex;
  justify-content: space-between;

  @media (${filterBreakpoint}) {
    flex-direction: column-reverse;
  }
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;

  @media (${filterBreakpoint}) {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 5px;
    margin-top: 15px;

    ${ButtonPillRow} {
      height: 44px;
    }
  }

  @media (${mobileXXLargeMax}) {
    align-items: center;
    text-align: center;
  }
`;

export const MiddleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  margin: 15px 0;

  label {
    text-align: right;
    align-items: flex-end;
    justify-content: flex-end;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 20px;
    margin: 20px 0 0;
  }
`;

export const SwitchRow = styled.div<{ $active?: boolean }>`
  display: flex;
  gap: 10px;
  align-items: center;
  color: ${(props) => props.theme.textDark};
  font-weight: bold;

  ${({ $active, theme }) =>
    $active &&
    css`
      color: ${theme.primary};
    `}
`;

export const SwitchLabel = styled.p`
  @media (${filterBreakpoint}) {
    display: none;
  }
`;

export const SwitchLabelMobile = styled.p`
  display: none;

  @media (${filterBreakpoint}) {
    display: block;
  }
`;

export const CoOwnershipBanner = styled.div`
  position: relative;
  background-color: rgba(232, 58, 79, 0.1);
  border-radius: 4px;
  border: solid 1px #e83a4f;
  padding: 12px;
  margin-top: 15px;
`;

export const CoOwnershipHide = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.white};
  padding: 4px 6px;
  background-color: #e83a4f;
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 20px;
  border-radius: 100%;
  cursor: pointer;
  transition: linear 150ms background-color;

  &:hover {
    background-color: ${({ theme }) => theme.buttonHover};
  }
`;

export const CoOwnershipBannerConent = styled.div`
  margin: 0 auto;
  max-width: 980px;
  display: flex;
  align-items: center;

  a {
    color: #e83a4f;
    text-decoration: underline;
    text-decoration-color: #e83a4f;
    font-weight: bold;
    transition: linear 150ms color;
    white-space: nowrap;

    &:hover {
      color: ${({ theme }) => theme.textDark};
      text-decoration-color: ${({ theme }) => theme.textDark};
    }
  }

  > :not(:last-child) {
    margin-right: 10px;
  }

  @media (${tabletMax}) {
    text-align: center;
    justify-content: center;
  }

  @media (${mobileXLargeMax}) {
    span {
      font-size: 13px;
    }

    > :not(:last-child) {
      margin-right: 6px;
    }

    img {
      max-width: 80px;
    }
  }
`;
